import { Auth } from 'aws-amplify';

const requestPasswordReset = async email => {
  return Auth.forgotPassword(email.trim()).then(data => {
    return data;
  });
};

export default requestPasswordReset;
